export default __webpack_public_path__ + "static/media/profilecut.d52b46e2.png";